import { useEffect, useState } from 'react'
import Popup from 'reactjs-popup'
import styles from './ListHotelPopUp.module.scss'

type ListHotelPopUpProps = {
  showPopup: JSX.Element
  viewRoomsButton: JSX.Element
}

export default function ListHotelPopUp({showPopup, viewRoomsButton} : ListHotelPopUpProps) {


  return (
    <Popup modal trigger={showPopup} contentStyle={{borderRadius: '10px', width: '30%', height: '25%'}}>
      {(close: Function) => (
        <div className={styles.modal}>
          <p>You have added a room from a different hotel already. By adding another room from this hotel will clear all the rooms in your cart. Would you like to proceed?</p>
          {viewRoomsButton}
        </div>
      )}
    </Popup>
  )
}